import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActions,
  Button,
  Grid,
  Box,
  Stack,
  Skeleton,
} from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getProductById, getAllProducts } from "../../../Redux/ProductRedux.js";
import StarRatings from "react-star-ratings";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const cardStyles = {
  card: {
    boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
    padding: "8px",
    margin: "8px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 6px 15px rgba(0, 0, 0, 0.3)",
    },
  },
  media: {
    height: "200px",
    objectFit: "cover",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
  },
  actions: {
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

function FeaturedCards({ sectionName }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allProducts } = useSelector((state) => state.productRedux);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const handleCardClick = (product) => {
    const productId = product._id;
    dispatch(getProductById(productId));
    navigate(`/productDetails/${productId}`, { state: { product } });
  };

  useEffect(() => {
    dispatch(getAllProducts())
      .catch((error) => {
        console.error("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  const featuredProducts = allProducts.filter((product) => product.isFeatured);
  // .filter((product, index) => (sectionName === 'home' ? index < 8 : true));

  return (
    <>
      {loading ? (
        <div className="row">
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
        </div>
      ) : (
        <Swiper
          modules={[Navigation, Autoplay]}
          // navigation
          autoplay={{ delay: 3000 }}
          loop={true}
          slidesPerView={6}
          slidesPerGroup={1}
          spaceBetween={20}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            960: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
            1600: { slidesPerView: 6 },
          }}
        >
          {featuredProducts.map((product) => (
            <SwiperSlide key={product._id}>
              <Grid item xs={12} sm={4} md={2} lg={2}>
                <Card sx={cardStyles.card}>
                  <CardMedia
                    component="img"
                    sx={cardStyles.media}
                    image={`${BASE_URL}/assets/images/products/${product.images[0]?.image}`}
                    alt={product.productName}
                    onClick={() => handleCardClick(product)}
                  />
                  <CardContent sx={cardStyles.content}>
                    <Typography
                      variant="h6"
                      component="div"
                      className="card-title"
                      onClick={() => handleCardClick(product)}
                    >
                      {product.productName}
                    </Typography>

                    <Box
                      className=""
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mt={1}
                    >
                      <StarRatings
                        rating={Number(product.rating) || 0}
                        starRatedColor="gold"
                        numberOfStars={5}
                        starDimension="16px"
                        starSpacing="2px"
                        name="rating"
                      />
                      <Box mt={0.5} display="flex" alignItems="center">
                        <CurrencyRupeeIcon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: "text.primary",
                          }}
                        />
                        <Typography variant="h5" fontWeight={600} ml={0.5}>
                          {product.priceAndQuantity &&
                          product.priceAndQuantity.length > 0
                            ? Math.min(
                                ...product.priceAndQuantity.map(
                                  (item) => item.price
                                )
                              ).toFixed(2)
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>

                  <CardActions sx={cardStyles.actions}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Button
                          startIcon={<ShoppingBagIcon />}
                          fullWidth
                          onClick={() => handleCardClick(product)}
                          // variant='contained'
                          sx={{
                            // backgroundColor: 'var(--primary-color)',
                            color: "var(--primary-color)",
                            "&:hover": {
                              backgroundColor: "var(--primary-color)",
                              color: "#fff",
                            },
                          }}
                        >
                          Buy Now
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            </SwiperSlide>
          ))}
        </Swiper>
        //     <Swiper
        //   modules={[Navigation, Autoplay]}
        //   navigation
        //   autoplay={{ delay: 3000 }}
        //   loop={true}
        //   slidesPerView={4}
        //   slidesPerGroup={1}
        //   spaceBetween={20}
        //   breakpoints={{
        //     0: { slidesPerView: 1 },
        //     600: { slidesPerView: 2 },
        //     960: { slidesPerView: 3 },
        //     1280: { slidesPerView: 4 },
        //   }}
        // >
        //   {featuredProducts.map((product) => (
        //     <SwiperSlide key={product._id}>
        //       <Card
        //         sx={{
        //           borderRadius: 3,
        //           boxShadow: 4,
        //           transition: 'transform 0.3s ease',
        //           height: '100%',
        //           display: 'flex',
        //           flexDirection: 'column',
        //           '&:hover': {
        //             transform: 'translateY(-5px)',
        //           },
        //         }}
        //       >
        //         <CardMedia
        //           component='img'
        //           image={product.images[0]?.image}
        //           alt={product.productName}
        //           height='200'
        //           sx={{
        //             objectFit: 'cover',
        //             borderTopLeftRadius: 12,
        //             borderTopRightRadius: 12,
        //             cursor: 'pointer',
        //           }}
        //           onClick={() => handleCardClick(product)}
        //         />

        //         <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 2 }}>
        //           <Typography
        //             variant='subtitle1'
        //             fontWeight={600}
        //             onClick={() => handleCardClick(product)}

        //           >
        //             {product.productName}
        //           </Typography>

        //           <Box display='flex' justifyContent='center' mt={1}>
        //             <StarRatings
        //               rating={Number(product.rating) || 0}
        //               starRatedColor='gold'
        //               numberOfStars={5}
        //               starDimension='16px'
        //               starSpacing='2px'
        //               name='rating'
        //             />
        //           </Box>

        //           <Box mt={1} display='flex' justifyContent='center' alignItems='center'>
        //             <CurrencyRupeeIcon fontSize='small' />
        //             <Typography variant='h6' fontWeight='bold' ml={0.5}>
        //               {product.priceAndQuantity?.length
        //                 ? Math.min(
        //                     ...product.priceAndQuantity.map((item) => item.price)
        //                   ).toFixed(2)
        //                 : 'N/A'}
        //             </Typography>
        //           </Box>
        //         </CardContent>

        //         <CardActions sx={{ px: 2, pb: 2 }}>
        //           <Button
        //             fullWidth
        //             startIcon={<ShoppingBagIcon />}
        //             onClick={() => handleCardClick(product)}
        //             variant='contained'
        //             sx={{
        //               backgroundColor: 'var(--primary-color)',
        //               // fontWeight: 'bold',
        //               color: '#fff',
        //               textTransform: 'none',
        //               borderRadius: 2,
        //               '&:hover': {
        //                 backgroundColor: 'var(--primary-color)',
        //               },
        //             }}
        //           >
        //             Buy Now
        //           </Button>
        //         </CardActions>
        //       </Card>
        //     </SwiperSlide>
        //   ))}
        // </Swiper>
      )}
    </>
  );
}

export default FeaturedCards;
